var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 90.449,
    viewBox: "0 0 150 90.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Adults",
    transform: "translate(-12.199 -25.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(12.2 25.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M43.1,25.9A30.929,30.929,0,0,0,12.2,56.8V70.844a31.7,31.7,0,0,0,3.371,14.045v3.933a27.528,27.528,0,0,0,55.056,0V84.889A29.906,29.906,0,0,0,74,70.844V56.8A30.929,30.929,0,0,0,43.1,25.9ZM65.758,88.821a22.659,22.659,0,0,1-45.318,0V61.293A22.768,22.768,0,0,1,34.485,40.319v4.12c0,5.805,2.809,12.734,12.734,12.734,6.18,0,13.67.562,18.539,5.056V88.821Z",
    transform: "translate(-12.2 -25.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M37.427,60.485A5.39,5.39,0,0,1,33.494,58.8a25.057,25.057,0,0,1-4.869.375c-6.554,0-9.925,3.371-9.925,9.925h4.869c0-3.933,1.124-5.056,5.056-5.056,2.434,0,6.367,0,8.8-1.5,2.434,1.5,6.367,1.5,8.8,1.5,3.933,0,5.056,1.124,5.056,5.056h4.869c0-6.554-3.371-9.925-9.925-9.925a25.056,25.056,0,0,1-4.869-.375A5.39,5.39,0,0,1,37.427,60.485Z",
    transform: "translate(-6.528 2.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M120.525,57.173V56.8a30.9,30.9,0,1,0-61.8,0v1.5C57.416,77.211,50.3,85.638,50.3,93.878c0,6.554,8.427,12.172,20.787,14.981a27.182,27.182,0,0,0,37.079,0h0c12.36-2.809,20.787-8.427,20.787-14.981C128.952,84.514,121.836,72.155,120.525,57.173Zm-8.24,31.648a22.659,22.659,0,0,1-45.318,0V60.544c7.865-7.3,22.285-8.989,22.659-14.794.375,5.805,14.794,7.491,22.659,14.794V88.821Z",
    transform: "translate(21.048 -25.9)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdults);
export default __webpack_public_path__ + "static/media/Adults.04c072fce53ea4617530a21ef35c34ac.svg";
export { ForwardRef as ReactComponent };